"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** One action surface for a viewport, dialog, or embedded form. */
export function FlowActionBar({
  children,
  fixed,
  embedded,
  lead,
  inset = 0,
}: {
  children: ReactNode;
  fixed: boolean;
  embedded: boolean;
  lead: boolean;
  inset?: number;
}) {
  return (
    <footer
      data-flow-footer={fixed ? "fixed" : "inline"}
      style={fixed ? { bottom: inset } : undefined}
      className={cn(
        "shrink-0 bg-background",
        fixed ? "fixed inset-x-0 z-50 border-t" : "border-t",
        embedded && "border-t-0",
        lead ? "py-3" : fixed ? "py-6" : "py-4",
        !embedded &&
          (lead
            ? "pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
            : fixed
              ? "pb-[calc(1.5rem+env(safe-area-inset-bottom))]"
              : "pb-[calc(1rem+env(safe-area-inset-bottom))]"),
      )}
    >
      <div
        className={cn(
          lead || !fixed
            ? "mx-auto w-full max-w-2xl px-4 sm:px-6"
            : "container px-4 sm:px-6",
        )}
      >
        {children}
      </div>
    </footer>
  );
}
